import {
    SIGN_OUT,
    GET_ROAD_TICKET_ORIGINS,
    GET_ROAD_TICKET_DESTINATIONS,
    GET_ROAD_TICKET_TRIPS,
    GET_ROAD_TICKET_CARRIERS_INFO,
    GET_ROAD_TICKET_BENEFITS,
    ROAD_TICKET_CHECK_VACANCY,
    GET_ROAD_TICKET_BUS_MAP,
    ROAD_TICKET_BLOCK_SEATS,
    ROAD_TICKET_UNBLOCK_SEAT,
    ROAD_TICKET_SEARCH_EVOM_ACCOUNT,
    CLEAR_ROAD_TICKET_EVOM_ACCOUNTS,
    ROAD_TICKET_CONFIRM_TICKET,
    DOWNLOAD_ROAD_TICKET,
    SHOW_DOWNLOAD_TICKET_DIALOG,
    HIDE_DOWNLOAD_TICKET_DIALOG,
    SHOW_SEARCH_TRIPS_LOADING_DIALOG,
    HIDE_SEARCH_TRIPS_LOADING_DIALOG,
    SHOW_SELECT_TRIP_LOADING_DIALOG,
    HIDE_SELECT_TRIP_LOADING_DIALOG,
    SHOW_CANCELLATION_CONDITIONS_LOADING_DIALOG,
    HIDE_CANCELLATION_CONDITIONS_LOADING_DIALOG,
    SHOW_CONFIRMATION_LOADING_DIALOG,
    HIDE_CONFIRMATION_LOADING_DIALOG,
    CLEAN_ROAD_TICKET_DATA,
    TOGGLE_INSURANCE
} from "constants/ActionTypes";

const INIT_STATE = {
    origins: [],
    destinations: [],
    doShowSearchTripsLoadingDialog: false,
    trips: [],
    carriersInfo: [],
    benefits: [],
    checkVacancy: null,
    doShowSelectTripLoadingDialog: false,
    busMap: null,
    transitAgencyIdList: [],
    blockedSeats: [],
    evomAccounts: [],
    doShowConfirmationLoadingDialog: false,
    confirmedRoadTicketList: [],
    doShowDownloadTicketDialog: false,
    roadTicketPDFData: null,
    doShowCancellationConditionsLoadingDialog: false,
    insuranceEngaged: false,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SIGN_OUT: {
            return INIT_STATE;
        }

        case GET_ROAD_TICKET_ORIGINS: {
            const originList = action.payload.data;
            const sortedOriginList = originList.length
                ? [...originList].sort((a, b) => a.city.localeCompare(b.city))
                : [];

            return {
                ...state,
                origins: sortedOriginList,
            };
        }

        case GET_ROAD_TICKET_DESTINATIONS: {
            const destinationList = action.payload.data;
            const sortedDestinationList = destinationList.length
                ? [...destinationList].sort((a, b) => a.city.localeCompare(b.city))
                : [];

            return {
                ...state,
                destinations: sortedDestinationList,
            };
        }

        case GET_ROAD_TICKET_TRIPS: {
            const trips = action.payload.data;
            const sortedTrips = trips.length
                ? [...trips].sort((a, b) => new Date(a.departureLocalDateTime) - new Date(b.departureLocalDateTime))
                : [];
            return {
                ...state,
                doShowSearchTripsLoadingDialog: false,
                trips: sortedTrips,
            };
        }

        case GET_ROAD_TICKET_CARRIERS_INFO: {
            return {
                ...state,
                carriersInfo: action.payload,
            };
        }

        case GET_ROAD_TICKET_BENEFITS: {
            return {
                ...state,
                benefits: action.payload,
            };
        }

        case ROAD_TICKET_CHECK_VACANCY: {
            return {
                ...state,
                checkVacancy: action?.payload?.data,
            };
        }

        case GET_ROAD_TICKET_BUS_MAP: {
            const seats = action.payload?.data;

            if (seats === null || seats === undefined || seats?.tripBusSeat?.length === 0) {
                return {
                    ...state,
                    busMap: [],
                    transitAgencyIdList: [],
                }
            }

            const tripBusSeat = seats?.tripBusSeat;

            var xList = [...tripBusSeat];
            var yList = [...tripBusSeat];
            var zList = [...tripBusSeat];

            // order by x to find the first and last index
            xList.sort((a, b) => a.x === b.x);
            var firstXIndex = xList.at(0).x;
            var lastXIndex = xList.at(-1).x;

            if (lastXIndex < 13) {
                lastXIndex = 13;
            }

            // order by y to find the first and last index
            yList.sort((a, b) => a.y === b.y);
            var firstYIndex = yList.at(0).y;
            var lastYIndex = yList.at(-1).y;

            if (lastYIndex < 4) {
                lastYIndex = 4;
            };

            // order by z to find the first and last index
            zList.sort((a, b) => a.z === b.z);
            var firstZIndex = zList.at(0).z;
            var lastZIndex = zList.at(-1).z;

            if (lastZIndex < firstZIndex) {
                let newFirstZIndex = lastZIndex;
                let newLastZIndex = firstZIndex;

                firstZIndex = newFirstZIndex;
                lastZIndex = newLastZIndex;
            }

            let seatMap = [];
            if (firstZIndex != null && lastZIndex != null) {
                // fluxo Distribusion
                for (var z = firstZIndex; z <= lastZIndex; z++) {
                    for (var x = firstXIndex; x <= lastXIndex; x++) {
                        let seat = [];
                        for (var y = firstYIndex; y <= lastYIndex; y++) {
                            var item = tripBusSeat.find(b => b.x === x && b.y === y && b.z === z);
                            seat = [...seat, item];
                        }
                        seatMap = [...seatMap, seat];
                    }
                }
            } else {
                // fluxo RJ
                for (var x = firstXIndex; x <= lastXIndex; x++) {
                    let seat = [];
                    for (var y = firstYIndex; y <= lastYIndex; y++) {
                        var item = tripBusSeat.find(b => b.x === x && b.y === y);
                        seat = [...seat, item];
                    }
                    seatMap = [...seatMap, seat];
                }
            }

            var transitAgencyIdList = state.transitAgencyIdList;
            if (!transitAgencyIdList.includes(seats?.transitAgencyId)) {
                transitAgencyIdList = [...state.transitAgencyIdList, seats?.transitAgencyId];
            }

            return {
                ...state,
                doShowSelectTripLoadingDialog: false,
                busMap: seatMap,
                transitAgencyIdList: transitAgencyIdList,
            }
        }

        case SHOW_SELECT_TRIP_LOADING_DIALOG: {
            return {
                ...state,
                doShowSelectTripLoadingDialog: true,
            }
        }

        case HIDE_SELECT_TRIP_LOADING_DIALOG: {
            return {
                ...state,
                doShowSelectTripLoadingDialog: false,
            }
        }

        case ROAD_TICKET_BLOCK_SEATS: {
            return {
                ...state,
                blockedSeats: [...state.blockedSeats, ...action?.payload?.data],
            };
        }

        case ROAD_TICKET_UNBLOCK_SEAT: {
            return {
                ...state,
                blockedSeats: [],
                transitAgencyIdList: [],
                insuranceEngaged: false
            };
        }

        case ROAD_TICKET_SEARCH_EVOM_ACCOUNT: {
            const trimmedData = action.payload.data;
            return {
                ...state,
                evomAccounts: {
                    ...state.evomAccounts,
                    [action.payload.index]: trimmedData
                }
            };
        }

        case CLEAR_ROAD_TICKET_EVOM_ACCOUNTS: {
            return {
                ...state,
                evomAccounts: [],
            };
        }

        case ROAD_TICKET_CONFIRM_TICKET: {
            return {
                ...state,
                evomAccounts: [],
                doShowConfirmationLoadingDialog: false,
                confirmedRoadTicketList: action?.payload?.data,
                insuranceEngaged: false
            };
        }

        case SHOW_DOWNLOAD_TICKET_DIALOG: {
            return {
                ...state,
                doShowDownloadTicketDialog: true,
            }
        }

        case HIDE_DOWNLOAD_TICKET_DIALOG: {
            return {
                ...state,
                doShowDownloadTicketDialog: false,
            }
        }

        case DOWNLOAD_ROAD_TICKET: {
            return {
                ...state,
                roadTicketPDFData: action?.payload,
            }
        }

        case SHOW_SEARCH_TRIPS_LOADING_DIALOG: {
            return {
                ...state,
                doShowSearchTripsLoadingDialog: true,
            }
        }

        case HIDE_SEARCH_TRIPS_LOADING_DIALOG: {
            return {
                ...state,
                doShowSearchTripsLoadingDialog: false,
            }
        }

        case SHOW_CONFIRMATION_LOADING_DIALOG: {
            return {
                ...state,
                doShowConfirmationLoadingDialog: true,
            }
        }

        case HIDE_CONFIRMATION_LOADING_DIALOG: {
            return {
                ...state,
                doShowConfirmationLoadingDialog: false,
            }
        }

        case SHOW_CANCELLATION_CONDITIONS_LOADING_DIALOG: {
            return {
                ...state,
                doShowCancellationConditionsLoadingDialog: true,
            }
        }

        case HIDE_CANCELLATION_CONDITIONS_LOADING_DIALOG: {
            return {
                ...state,
                doShowCancellationConditionsLoadingDialog: false,
            }
        }

        case CLEAN_ROAD_TICKET_DATA: {
            return INIT_STATE;
        }

        case TOGGLE_INSURANCE: {
            return {
                ...state,
                insuranceEngaged: !state.insuranceEngaged,
            }
        }

        default: {
            return state;
        }
    }
}